import React from 'react';

const GateDeliveryIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 165 148.403079"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="donaska-C-(1)" transform="translate(0, -0)">
          <polyline
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
            points="114.689791 60.9676163 89.9260674 63.6513696 84.9956873 46.400122 74.3928285 42.8421157 64.7963773 39.2434465 60.4759411 45.7495151 57.7718563 84.7147668 59.3272134 95.3481227 81.7426529 113.687104 88.421539 147.711809 98.4144538 148.403079 101.088041 143.005075 94.8462818 105.056397 78.7945906 89.7976329"
          ></polyline>
          <polyline
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
            points="72.9086316 56.1592249 83.2878442 77.2836165 103.121188 74.305057"
          ></polyline>
          <polyline
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
            points="54.7424681 104.578608 51.3166164 111.247328 22.9135605 127.03471 22.3646109 134.892821 27.335654 139.18276 61.1570452 121.138585 65.3961555 112.945005"
          ></polyline>
          <path
            d="M94.1448463,5.06625467 C94.1448463,5.06625467 96.9200912,14.9473464 96.8489311,15.8622623 C96.7777709,16.7771782 89.0518144,34.1910775 89.0518144,34.1910775 L72.5223338,33.5303049 L65.1521779,27.7053404 L67.3581418,5.08658614 C67.3581418,5.08658614 75.1654242,1.48791693 79.8009981,0.0037200184 C80.3194504,-0.158931697 94.1448463,5.06625467 94.1448463,5.06625467 L94.1448463,5.06625467 Z"
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
          ></path>
          <polyline
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
            fill="#FFFFFF"
            fill-rule="nonzero"
            points="163.007516 112.812851 118.847576 129.098354 101.423511 83.5355418 145.125993 67.4533534 159.693488 105.219049"
          ></polyline>
          <polyline
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
            points="132.246011 70.6657248 128.931982 62.0146867 123.188343 59.9713745 117.800505 62.0248524 112.412667 64.0884961 109.495102 69.4560027 112.798965 78.0968751"
          ></polyline>
          <path
            d="M148.480685,105.31054 C147.382786,101.793197 145.237817,100.664801 143.509642,100.369994 C144.526215,99.3737527 145.441131,97.6862411 144.617707,95.0533165 C142.767544,89.1266946 137.471197,90.7837089 135.732857,91.3224927 L130.416179,92.9795071 L137.786335,116.685995 L143.407985,114.927323 C145.603783,114.236053 150.757809,112.629868 148.470519,105.300375 L148.480685,105.31054 Z M136.505453,95.2058025 L137.400037,94.9313277 C138.497936,94.5856928 139.280697,95.2261339 139.788984,96.8831483 C140.297271,98.5198312 140.01263,99.4449128 138.914731,99.7905477 L138.020147,100.065022 L136.505453,95.2058025 L136.505453,95.2058025 Z M142.066108,111.247328 L141.547656,111.40998 L139.17904,103.806012 L139.951636,103.5722 C140.897049,103.277394 142.279588,103.277394 143.357156,106.743909 C144.373729,110.02744 143.336825,110.850864 142.066108,111.247328 L142.066108,111.247328 Z"
            id="Shape"
            fill="#4C2B17"
            fill-rule="nonzero"
          ></path>
          <path
            d="M133.720042,94.7483445 C132.449325,91.2919955 130.243361,90.2754223 128.494856,90.0721077 C129.338611,89.147026 130.314522,87.3883544 129.328446,84.704601 C127.183476,78.8898022 121.978621,80.8314571 120.270778,81.4617325 L115.055758,83.4135531 L123.655967,106.69308 L129.17596,104.639602 C131.331095,103.836509 136.383464,101.945683 133.720042,94.7483445 L133.720042,94.7483445 Z M121.236523,85.2942135 L122.110776,84.9689101 C123.188343,84.5724465 124.001602,85.1722247 124.60138,86.7885762 C125.190993,88.3947619 124.967346,89.340175 123.879613,89.7468042 L123.015526,90.0721077 L121.246688,85.2942135 L121.236523,85.2942135 Z M127.630768,101.030767 L127.122482,101.223916 L124.367568,93.7622685 L125.119832,93.4877937 C126.05508,93.1421588 127.437619,93.0709987 128.688004,96.476519 C129.887561,99.7092218 128.891319,100.583475 127.640934,101.040933 L127.630768,101.030767 Z"
            id="Shape"
            fill="#4C2B17"
            fill-rule="nonzero"
          ></path>
          <line
            x1="49.0699895"
            y1="54.2988959"
            x2="12.8901485"
            y2="54.2988959"
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
          ></line>
          <line
            x1="48.0229191"
            y1="85.8025001"
            x2="0"
            y2="85.8025001"
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
          ></line>
          <line
            x1="48.0229191"
            y1="70.0557809"
            x2="25.9226172"
            y2="70.0557809"
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
          ></line>
          <path
            d="M158.54476,37.2916259 L163.830941,29.08788 L165,18.2715409 L155.718686,8.95973012 L145.939252,7.27221857 L135.824348,13.9714361 L132.469657,23.1104294 L132.489988,23.0596007 L132.489988,23.1002637 C132.357834,23.7915335 132.286674,24.5031347 132.256176,25.2249017 C132.164685,27.3292083 132.307005,29.4538463 132.58148,31.5784844 C132.937281,34.5062152 133.547224,37.3932832 134.126671,40.1786938 C134.512969,42.0593543 134.93993,43.9400148 135.387222,45.790178 C136.210646,49.246527 137.095065,52.6723788 137.857495,56.1490592 C140.398928,53.9329296 142.981024,51.7981258 145.522457,49.6124934 C147.128643,48.260451 148.714497,46.8779114 150.28002,45.4547089 C152.78079,43.1979163 155.42388,40.819135 157.721336,38.2065418 C157.99581,37.9015698 158.270285,37.5864321 158.534594,37.2712944 L158.626086,37.1391399"
            id="Path"
            stroke="#4C2B17"
            stroke-width="5"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
          <circle
            id="Oval"
            stroke="#4C2B17"
            stroke-width="5"
            cx="148.694165"
            cy="23.4357328"
            r="5.78430165"
          ></circle>
        </g>
      </g>
    </svg>
  );
};

export default GateDeliveryIcon;
